import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqData = [
    {
      question: "What is iFLO Pro®?",
      answer: "The first-of-its-kind, iFLO Pro® is a smart automated device that dispenses a bio-enzymatic cleaning solution directly into the A/C drain pan and drain line, actively breaking down and flushing out the build-up that leads to clogs, floods and shut-downs."
    },
    {
      question: "Is the device installed on the homeowner's app on their phone or the company's app?",
      answer: "The iFLO Pro device will connect to the contractor's phone and be saved in the company's panel within the iFLO Pro App. The contractor has the option to share the device with the homeowner's app so they can see it on their phone."
    },
    {
      question: "How do I share a device/location?",
      answer: "To share a device, you must also share the location. Within the iFLO Pro App, use the menu at the bottom of the screen to navigate to \"Locations\" > Tap the customer's home > Tap the \"Share\" button located at the top of the devices list, below the location title > Follow the prompts to share the device."
    },
    {
      question: "When should I 'share the device' with the homeowner?",
      answer: "Sharing the device can be done any time after a fully completed install of the iFLO Pro."
    },
    {
      question: "What is the difference between retail and Pro?",
      answer: "iFLO Pro offers a multitude of benefits the retail kit does not include. Most importantly, a float switch monitor that alerts both contractors and professionals within 15s of a trip on the system, and our strongest zooglea preventing formula that can break down bacteria within a day of first use."
    },
    {
      question: "Is the chemical solution eco-friendly?",
      answer: "Yes, the iFLO formula is comprised of bio-enzymes that do not harm pets, plants, people, or metal and electrical components in the air handler."
    },
    {
      question: "Why can't connect to the Wi-Fi in my customer's home?",
      answer: "The iFLO doesn't connect to 5ghz network only 2.4ghz"
    },
    {
      question: "How to connect to Wi-Fi?",
      answer: "The iFLO Pro App will walk you through the set-up process, including how to connect to Wi-Fi. Make sure your customer has written out the Wi-Fi password for you correctly, all capital and lowercase letters must be correct to connect to a Wi-Fi network."
    },
    {
      question: "Is a phone required for install?",
      answer: "Yes, iFLO Pro is a smart device and needs a phone to be able to complete install."
    },
    {
      question: "Is Wi-Fi required for install?",
      answer: "No, Wi-Fi is not required, but your iFLO Pro device will lose certain benefits and remain in \"dummy\" mode"
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-8">Frequently Asked Questions</h1>
      <div className="space-y-4">
        {faqData.map((faq, index) => (
          <div
            key={index}
            className="border border-gray-200 rounded-lg overflow-hidden"
          >
            <button
              className="w-full px-6 py-4 flex justify-between items-center bg-white hover:bg-gray-50 transition-colors"
              onClick={() => toggleFAQ(index)}
            >
              <span className="text-lg font-medium text-gray-800">{faq.question}</span>
              {openIndex === index ? (
                <ChevronUpIcon className="h-5 w-5 text-gray-500" />
              ) : (
                <ChevronDownIcon className="h-5 w-5 text-gray-500" />
              )}
            </button>
            <AnimatePresence>
              {openIndex === index && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <div className="px-6 py-4 bg-gray-50">
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
      
      <div className="mt-12 text-center">
        <p className="text-gray-600 mb-4">
          Still have questions? We're here to help!
        </p>
        <button onClick={() => navigate("/dashboard/contact")} className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors">
          Contact Support
        </button>
      </div>
    </div>
  );
};

export default FAQ;
